import React, { type ReactNode, type ReactElement, cloneElement, isValidElement, Children } from "react"

const VISUALISER_TYPES = new Set<string>(["INSERT", "GREETINGS_CARD"])

/**
 * Clones Visualiser children so grouped layout can strip margins (isGrouped).
 */
export function mapVisualiserGroupChildren(options: { children: ReactNode }): ReactNode {
  const { children } = options
  return Children.map(children, (child) => {
    if (!isValidElement(child)) {
      return child
    }
    if (typeof child.type === "string") {
      return child
    }
    const visualiserType = (child.props as { type?: string })?.type
    if (!visualiserType || !VISUALISER_TYPES.has(visualiserType)) {
      return child
    }
    return cloneElement(child as ReactElement<{ isGrouped?: boolean }>, { isGrouped: true })
  })
}
